<template lang="pug">

    v-card(:class="{'pa-5': !noPadding, 'elevation-5': noPadding}")
        h1(v-if="formTitle") {{formTitle}}
        v-card-actions
            .controls-area
                .switch-container(v-if="editable")
                    span.mr-2.title.pt-1 Editar
                    v-switch.switch(v-model="editSwitch")
        v-divider.mb-4(v-if="editable")
        v-form(ref="form")
            v-layout(row wrap)
                
                v-flex.pl-5(:class="setVFlexClass(field, idx)" v-for="(field, idx) in fields" :key="idx" row wrap)
                    
                    v-text-field.mx-3(
                        v-if="field.type == 'text' || field.type == 'password'" 
                        :type="field.type == 'password' ? 'password' : 'text'" 
                        v-bind="field.vuetifyProps"  
                        v-model="vmodels[field.field]" 
                        :rules="setRules(field)"
                        :maxlength="''+field.maxLength"
                        :readonly="!formIsFillable || field.readonly"
                        :single-line = 'showLabels'
                        :outline = 'showLabels'
                        :mask="setMask(field)"
                        @input = "sendOnInput({field: field.field, value: vmodels[field.field], vmodels: vmodels})"
                    )
                        div.formLabel(slot="prepend" v-if="showLabels")
                            |{{field.vuetifyProps.label}}
                    v-autocomplete.mx-3(
                        v-else-if="field.type == 'autocomplete'" 
                        v-bind="field.vuetifyProps" 
                        v-model="vmodels[field.field]" 
                        :items="field.options"
                        :maxlength="''+field.maxLength"
                        :readonly="!formIsFillable"
                        :rules="setRules(field)"
                    )
                        div.formLabel(slot="prepend" v-if="showLabels")
                            |{{field.vuetifyProps.label}}
                    v-autocomplete.mx-3(
                        v-else-if="field.type == 'autocompleteObject'" 
                        v-bind="field.vuetifyProps" 
                        v-model="vmodels[field.field]" 
                        :items="field.options.data"
                        :item-text ='field.options.text'
                        :item-value ='field.options.value'
                        :maxlength="''+field.maxLength"
                        :readonly="!formIsFillable"
                        hide-selected = true
                        @input="autocompleteObjSelectId($event,field.options.text,{field: field.field, value: vmodels[field.field], vmodels: vmodels})"
                        :single-line = 'showLabels'
                        :outline = 'showLabels'
                        :rules="setRules(field)"
                        @keyup="autocompleteObjSelectId($event,field.options.text,{field: field.field, value: vmodels[field.field], vmodels: vmodels})"
                    )
                        div.formLabel(slot="prepend" v-if="showLabels")
                            |{{field.vuetifyProps.label}}
                    v-select.mx-3(
                        v-else-if="field.type == 'select'" 
                        v-bind="field.vuetifyProps" 
                        v-model="vmodels[field.field]" 
                        :items="field.options"
                        :readonly="!formIsFillable"
                    )
                        div.formLabel(slot="prepend" v-if="showLabels")
                            |{{field.vuetifyProps.label}}
                    rut-input.mx-3(
                        v-else-if="field.type == 'rut'" 
                        v-bind="field.vuetifyProps" 
                        v-model="vmodels[field.field]"
                        :readonly="!formIsFillable"
                    )
                        div.formLabel(slot="prepend" v-if="showLabels" )
                            |{{field.vuetifyProps.label}}
                    v-textarea.mx-3(v-else-if="field.type == 'textarea'" 
                        v-bind="field.vuetifyProps" 
                        v-model="vmodels[field.field]"
                        :maxlength="''+field.maxLength"
                        :readonly="!formIsFillable"
                    )
                        div.formLabel(slot="prepend" v-if="showLabels" )
                            |{{field.vuetifyProps.label}}
                    v-layout.checkTitle( v-else-if="field.type == 'checkbox'" row)
                        v-checkbox.mx-3(
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]"
                            :readonly="!formIsFillable"
                            
                        )
        v-layout(row wrap)
            v-flex.xs12
                slot( name="appendContent" )
        v-divider.mb-4
        v-layout(row wrap v-if="!noButtons")
            v-flex.px-3(xs12 md4 offset-md2)
                v-btn.subheading.mt-3(block outline color="secondary" @click="resetForm()" :disabled="!formIsFillable") {{editable ? 'Restaurar Valores' : 'Limpiar'}}
            v-flex.px-3(xs12 md4)
                v-btn.subheading.mt-3(block color="secondary" @click="submitForm()" :disabled="!formIsSubmittable") {{submitText}}
            //- <slot></slot>
            //- v-divider.my-4
            //- v-layout( justify-center row wrap )
            //-     v-flex.px-3( xs12 md4 v-if="reset" )
            //-         v-btn.subheading(block outline color="secondary" @click="resetForm()" :disabled="!formIsFillable") {{editable ? 'Restaurar Valores' : 'Limpiar'}}
            //-     v-flex.px-3( xs12 md4 )
            //-         v-btn.subheading(block color="secondary" @click="submitForm()" :disabled="!formIsSubmittable") {{submitText}}
</template>

<script>
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import RUTInput from '@/components/RUTInput/RUTInput'
import JSUtils from '@/mixins/JSUtils'
export default {
    name: 'crud-form',
    props: {
        noButtons: {
            type: Boolean,
            default: () => false
        },
        fields: {
            type: Array,
            default: () => [],
        },
        toolbarTitle: {
            type: String,
            default: () => 'title',
        },
        toolbarIcon: {
            type: String,
            default: () => 'info',
        },
        customRules: {
            type: Object,
            default: () => {},
        },
        editable: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        submitText: {
            type: String,
            default: 'Enviar',
        },
        showLabels : {
            type: Boolean,
            default: true,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        formTitle: {
            type: String,
            default: null
        // /**
        //  * 
        //  */
        // reset: {
        //     type: Boolean,
        //     default: true,
        }
    },
    data: function() {
        return {
            vmodels: {},
            editSwitch: false,
        }
    },
    computed: {
        formIsValid: function() {
            return this.$refs.form.validate()
        },
        formIsFillable: function() {
            if (!this.editable && !this.readOnly && !this.disabled) return true
            if (this.editable && this.editSwitch) return true
            return false
        },
        formIsSubmittable: function() {
            if (!this.editable && !this.readOnly && !this.disabled) return true
            if (this.editable && this.editSwitch) return true
            return false
        },
    },
    methods: {
        /**
         * 
         */
        resetForm () {
            //
            if ( this.editable ) return this.setVmodels()
            //
            this.$emit( 'reset' ) //this.$refs.form.reset()
        },
        /**
         * 
         */
        toggleReadOnlyForm: function(bool) {
            this.fields.forEach(field => {
                let fieldProps
                if (field.type == 'rut') {
                    fieldProps = field.vuetifyProps
                    fieldProps.textFieldProps.readonly = bool
                    field.vuetifyProps = this.mixDeepClone(fieldProps)
                    return
                }
                if (
                    field.type == 'select' ||
                    field.type == 'checkbox' ||
                    field.type == 'autocomplete'
                ) {
                    fieldProps = field.vuetifyProps
                    fieldProps.disabled = bool
                    field.vuetifyProps = this.mixDeepClone(fieldProps)
                    return
                }
                fieldProps = field.vuetifyProps
                fieldProps.readOnly = bool
                field.vuetifyProps = this.mixDeepClone(fieldProps)
            })
        },
        disabledForm: function() {},
        submitForm: function() {
            if (this.formIsValid) {
                this.$emit('submitForm', this.mixDeepClone(this.vmodels))
            }
            
        },
        setRules: function(field) {
            if (!field.rules) return []
            let rules = field.rules.map(ruleName => {
                return this.mixRules[ruleName]
            })
            if (!field.customRules) return rules
            let customRules = field.customRules.map(ruleName => {
                return this.customRules[ruleName]
            })
            rules = rules.concat(customRules)
            return rules
        },
        setVFlexClass: function(field, idx) {
            if (field.type != 'textarea') return { md6: true, xs12: true }
            if (field.type == 'textarea') return { md12: true, xs12: true }
            if (field.type == 'checkbox') return { md12: true, xs12: true, 'text-sm-center': true }
        },
        setVmodels: function() {
            let vmodels = {}
            this.fields.forEach(field => {
                vmodels[field.field] = field.value
            })
            this.vmodels = this.mixDeepClone(vmodels)
        },
        autocompleteObjSelectId : function ( event, selectType, field ){
            let payload = {
                id : event,
                type : selectType
            }
            this.sendOnInput( field )
            //
            this.$emit( 'autocompleteObjSelectId', payload )
            this.$emit( 'autocompleteObjectValue', event.target.value )
        },
        textWrite: function (event, type){
            let payload = {
                value : event,
                label : type,
                // value : value, 
            }
            this.$emit('textWrite',payload)
        },
        setMask(field){
            if(field.vuetifyProps.mask) return field.vuetifyProps.mask
            if(field.format && field.format === 'currency') return mixCurrencyMask(this.vmodels[field.field], field.maxLength || 10)
            if(field.format === 'number'){
                let mask = ''
                for (let idx = 0; idx < (field.maxLength || 10); idx++) {
                    mask += '#'
                }
                return mask
            }
            return ''
        },

        sendOnInput(field){
            this.$emit('calculate', field)
        }
    },
    watch: {
        formIsFillable: function(newVal, oldVal) {
            this.toggleReadOnlyForm(newVal ? false : true)
        },
        fields: function (newVal){
            console.log(newVal,'here in crudform field watch')
            this.setVmodels()
             deep: true
        },
        vmodels: {
            deep: true,
            handler:function(newVal, oldVal){
                if(newVal !== oldVal){
                    

                }
            }
        },
       
    },
    components: {
        'rut-input': RUTInput,
    },
    mixins: [InputValidations, JSUtils, CurrencyUtils],
    filters: {},
    created: function() {
        this.setVmodels()
    },
    // beforeUpdate: function(){
    //     this.setVmodels()
    // }
}
</script>

<style lang="scss" >
.controls-area {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .switch-container {
        display: flex;
        flex-direction: row;
        // padding-top: 2.5%;
        span {
            margin-top: 1px;
        }
    }
    .switch{
        margin-top:-2px;
        margin-left:10px;
    }
}
.formLabel{
    
        font-weight: bold;
        min-width: 150px;
        max-width: 150px;
        font-size:20px;
    }

</style>